/* Predictive search: /search/suggest.json overlay. specs/01-global.md "Search" */

function velourFormatINR(cents) {
  return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
}

class VelourSearch {
  constructor() {
    this.input = document.querySelector('[data-search-input]');
    this.results = document.querySelector('[data-search-results]');
    if (!this.input || !this.results) return;
    this.input.addEventListener('input', debounce(this.onInput.bind(this), 300));
  }

  onInput(event) {
    const query = event.target.value.trim();
    if (query.length < 2) {
      this.results.innerHTML = '';
      return;
    }
    fetch(
      `${window.routes.predictive_search_url}.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=8&resources[options][unavailable_products]=last`
    )
      .then((r) => r.json())
      .then((data) => this.render(data.resources.results))
      .catch(() => {
        this.results.innerHTML = '';
      });
  }

  render(results) {
    const products = results.products || [];
    const collections = results.collections || [];
    const pages = results.pages || [];

    if (!products.length && !collections.length && !pages.length) {
      this.results.innerHTML = '<p class="text-small">No results. Try another search.</p>';
      return;
    }

    const productCards = products
      .map((product) => {
        const image = product.featured_image ? product.featured_image.url : '';
        const price = velourFormatINR(product.price);
        return `<a href="${product.url}" class="search-result-card">
          ${image ? `<img src="${image}" alt="${product.title}" width="200" height="250" loading="lazy">` : ''}
          <span class="product-name" style="font-size:17px">${product.title}</span>
          <span class="price-row__current tabular-nums">${price}</span>
        </a>`;
      })
      .join('');

    const otherLinks = collections
      .concat(pages)
      .map((item) => `<a href="${item.url}" class="mega-panel__link">${item.title}</a>`)
      .join('');

    this.results.innerHTML = productCards + (otherLinks ? `<div class="search-overlay__other">${otherLinks}</div>` : '');
  }
}

document.addEventListener('DOMContentLoaded', () => new VelourSearch());
